module.exports = __webpack_public_path__ + "media/images/stepimage-cef3d8c44af38164afd4b009f10c33c7.jpeg";